module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGP6zwAAAgcBApocMXEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// E:/PROJETO SUFRAMA/DESENVOLVIMENTO/Projetos/SCIEX/sciex/src/Suframa.Sciex.UserInterface/www/assets/images/watermark.png
// module id = ../../../../../www/assets/images/watermark.png
// module chunks = styles